import Vue from 'vue';
import { modernNotificationsRepository } from '@/shells/api/modernNotificationsRepository';

const STALE_AFTER_MS = 60000;

export class ModernNotificationsController {
  constructor(repository = modernNotificationsRepository, clock = () => Date.now()) {
    this.repository = repository;
    this.clock = clock;
    this.pending = null;
    this.state = Vue.observable({ status: 'idle', items: [], unreadCount: 0, loadedAt: 0, error: null });
  }

  load({ force = false } = {}) {
    if (this.pending) return this.pending;
    if (!force && this.state.loadedAt && this.clock() - this.state.loadedAt < STALE_AFTER_MS) {
      return Promise.resolve(this.state);
    }

    this.state.status = 'loading';
    this.pending = this.repository.getPreview(3)
      .then(preview => {
        Object.assign(this.state, preview, { status: 'ready', loadedAt: this.clock(), error: null });
        return this.state;
      })
      .catch(error => {
        this.state.status = 'error';
        this.state.error = error;
        throw error;
      })
      .finally(() => { this.pending = null; });
    return this.pending;
  }

  async markAllRead() {
    const unreadCount = await this.repository.markAllRead();
    this.state.unreadCount = unreadCount;
    this.state.items = this.state.items.map(item => ({ ...item, read: true }));
  }
}

export const modernNotificationsController = new ModernNotificationsController();
